<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
     (click)="close.emit()">
  @if (failed()) {
    <div class="w-80 h-80 max-h-[90vh] max-w-[90vw] bg-gray-200 rounded shadow-lg border-4 border-white flex items-center justify-center text-gray-500"
         (click)="$event.stopPropagation()">
      Couldn't load photo
    </div>
  } @else {
    @if (loading()) {
      <div class="w-80 h-80 max-h-[90vh] max-w-[90vw] bg-gray-200 animate-pulse rounded shadow-lg border-4 border-white"
           (click)="$event.stopPropagation()">
      </div>
    }
    @if (url()) {
      <img [src]="url()"
           [alt]="'Photo ' + (index() + 1)"
           class="max-h-[90vh] max-w-[90vw] rounded shadow-lg border-4 border-white"
           [class.hidden]="loading()"
           (load)="onImageLoad()"
           (error)="onImageError()"
           (click)="$event.stopPropagation()" />
    }
  }

  @if (hasPrevious()) {
    <button
      class="absolute left-6 top-1/2 -translate-y-1/2 text-white text-3xl font-bold bg-black/70 rounded-full w-12 h-12 flex items-center justify-center transition"
      (click)="previous(); $event.stopPropagation()"
      aria-label="Previous photo"
    >&lsaquo;</button>
  }

  @if (hasNext()) {
    <button
      class="absolute right-6 top-1/2 -translate-y-1/2 text-white text-3xl font-bold bg-black/70 rounded-full w-12 h-12 flex items-center justify-center transition"
      (click)="next(); $event.stopPropagation()"
      aria-label="Next photo"
    >&rsaquo;</button>
  }

  <div class="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-sm bg-black/70 rounded-full px-4 py-1"
       (click)="$event.stopPropagation()">
    {{ index() + 1 }} / {{ photos().length }}
    @if (current()?.numberOfPrints; as prints) {
      · ×{{ prints }}
    }
  </div>

  <button
    class="absolute top-6 right-6 text-white text-3xl font-bold bg-black/70 rounded-full w-12 h-12 flex items-center justify-center transition"
    (click)="close.emit(); $event.stopPropagation()"
    aria-label="Close"
  >&times;</button>
</div>
